import { memo } from 'react';
import Button from '../Button';

const SuccessButton = ({ onClick, disabled = false, loading = false, children, ...props }) => (
  <Button
    variant="contained"
    disabled={disabled}
    size="medium"
    onClick={onClick}
    loading={loading}
    {...props}>
    {children}
  </Button>
);

export default memo(SuccessButton);
